// extracted by mini-css-extract-plugin
module.exports = {"flex":"staffCard_flex__2aw1G","container":"staffCard_container__1O2Ju","staffInfo":"staffCard_staffInfo__28nhM","editButton":"staffCard_editButton__3Zz1a"};